export default {
  methods: {
    goToSubscription (subscriptionName) {
      if (this.$cookies.get('api_token') == null) {
				window.location.href = `/inicio-sesion?returnUrl=/HomePaciente#/profile/addsubscription/${subscriptionName}`
        /* this.$router.push({path: '/inicio-sesion', query: { returnUrl: `/HomePaciente#/profile/addsubscription/${subscriptionName}` } }) */
      } else {
        this.$helpers.goToWebApp(`homepaciente#/profile/addsubscription/${subscriptionName}`)
      }
    },
    getWellness () {
      this.goToSubscription('wellwopass')
    },
    getOpensaludpass () {
      this.goToSubscription('opensaludpass')
    },
    getOpensaludpassSingle () {
      this.goToSubscription('singlepass')
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixins/opensaludprime.mixin.js